import React, { useCallback } from "react";
const useErrors = () => {
    const [errors, setErrors] = React.useState([]);
    const addError = useCallback((message, detail) => {
        setErrors((prevErrors) => [...prevErrors, { message, detail }]);
    }, []);
    function clearErrors() {
        setErrors([]);
    }
    return [errors, addError, clearErrors];
};
export default useErrors;
